import { Message } from '../../hooks/useAuthForm';
import { CheckCircle, AlertTriangle } from 'lucide-react';

interface AuthMessageProps {
  message: Message;
}

export default function AuthMessage({ message }: AuthMessageProps) {
  if (!message) return null;

  const isSuccess = message.type === 'success';

  return (
    <div
      className={`p-4 rounded-lg border text-sm flex items-start gap-3 ${
        isSuccess
          ? 'bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-200 border-green-200 dark:border-green-800'
          : 'bg-orange-50 dark:bg-orange-900/20 text-orange-800 dark:text-orange-200 border-orange-200 dark:border-orange-800'
      }`}
    >
      {isSuccess ? (
        <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
      ) : (
        <AlertTriangle className="w-5 h-5 text-orange-600 dark:text-orange-400 flex-shrink-0 mt-0.5" />
      )}
      <span>{message.text}</span>
    </div>
  );
}
